import { useScanDeviceApiUpsert } from '@hooks/api/useScanDeviceApiUpsert';
import type { DeepScanVersion } from 'types/api';

export const useDeepScanVersionUpsert = useScanDeviceApiUpsert<
  DeepScanVersion,
  Partial<Omit<DeepScanVersion, 'id'>>
>('/deepscan-versions');
